import { withOptionsEndpoint } from "@dgs/core";
import { IndustryOptionResource } from "../types/industry";

const baseKey = ["industries"];
const quickFilterKey = [...baseKey, "quick-filter"];

export const industryService = {
	...withOptionsEndpoint<IndustryOptionResource>(baseKey),
	quickFilterKey,
};
